import { IdmAction } from '@kfolks/types'
import { z } from 'zod'

export const idmRequestCreateSchema = z.object({
	email: z.email(),
	action: z.enum(IdmAction),
	entraDirectoryId: z.uuid().optional(),
	contractType: z.string().optional(),
	geoLocation: z.string().optional(),
	department: z.string().optional(),
	leadershipType: z.string().optional(),
	providers: z
		.array(
			z.object({
				providerId: z.string(),
				role: z.string(),
			}),
		)
		.optional(),
	projects: z
		.array(
			z.object({
				projectId: z.string(),
				environment: z.string().nullable().optional(),
			}),
		)
		.optional(),
})

export const idmRequestConfirmSchema = z.object({
	confirmed: z.literal(true),
	overrideSignals: z.array(z.string()).optional(),
	overrideJustification: z.string().optional(),
})

export type IdmRequestCreateInput = z.infer<typeof idmRequestCreateSchema>
export type IdmRequestConfirmInput = z.infer<typeof idmRequestConfirmSchema>
